import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "references-section",
  id: "references"
}
const _hoisted_2 = { class: "section-shell" }
const _hoisted_3 = { class: "project-grid" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "project-copy" }
const _hoisted_6 = { class: "project-arrow" }

import { ArrowUpRight } from "lucide-vue-next";
import "@/assets/styles/reference.css";
import heroImage from "@/assets/images/hero-garden-v2.png";
import detailImage from "@/assets/images/team-freiraum-v2.png";
import beforeAfterImage from "@/assets/images/before-after-v2.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReferencesView',
  setup(__props) {

const projects = [
  { type: "Vorher / Nachher", title: "Vom Resthof zum Freiraum", place: "Wiesbaden · 540 m²", image: beforeAfterImage },
  { type: "Privat", title: "Garten mit Haltung", place: "Taunus · 620 m²", image: heroImage },
  { type: "Team", title: "Menschen, die anpacken", place: "Freiraum GaLaBau · Rhein-Main", image: detailImage }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section-heading reveal" }, [
        _createElementVNode("div", null, [
          _createElementVNode("span", { class: "eyebrow" }, "Ausgewählte Arbeiten"),
          _createElementVNode("h2", null, [
            _createTextVNode("Räume mit "),
            _createElementVNode("em", null, "Wirkung.")
          ])
        ]),
        _createElementVNode("p", null, "Drei Beispiele dafür, wie aus Anforderungen eigenständige Orte werden – präzise geplant und handwerklich stark umgesetzt.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projects, (project) => {
          return _createElementVNode("article", {
            class: "project-card reveal",
            key: project.title
          }, [
            _createElementVNode("img", {
              src: project.image,
              alt: project.title
            }, null, 8, _hoisted_4),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "project-overlay" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(project.type), 1),
              _createElementVNode("h3", null, _toDisplayString(project.title), 1),
              _createElementVNode("p", null, _toDisplayString(project.place), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ArrowUpRight))
            ])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})